import { render, staticRenderFns } from "./digitalHuman_customizePhotos.vue?vue&type=template&id=78b1e4c6&scoped=true"
import script from "./digitalHuman_customizePhotos.vue?vue&type=script&lang=js"
export * from "./digitalHuman_customizePhotos.vue?vue&type=script&lang=js"
import style0 from "./digitalHuman_customizePhotos.vue?vue&type=style&index=0&id=78b1e4c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1e4c6",
  null
  
)

export default component.exports